import { CSSProperties } from "react";
import { handleRemoveUnderscore } from "utils";

interface Props {
  statusString: string;
  styles?: CSSProperties;
}

const StatusField = ({ statusString, styles }: Props) => {
  const returnStatusColor = (text: string) => {
    switch (text && text?.toLowerCase()) {
      case "buy":
      case "active":
      case "match":
      case "success":
      case "finished":
      case "completed":
      case "complete":
      case "mapped":
      case "high":
      case "paid":
      case "stop_loss_hit":
      case "approved":
      case "true":
      case "auto":
      case "cash":
      case "live":
      case "sent":
        return {
          color: "var(--success-700)",
          bg: "var(--success-100)",
        };
      case "inactive":
      case "sell":
      case "not match":
      case "unmapped":
      case "low":
      case "failed":
      case "rejected":
      case "kyc rejected":
      case "false":
        return {
          color: "var(--warning-700)",
          bg: "var(--warning-100)",
        };
      case "moderate":
      case "manual":
      case "emandates":
        return {
          color: "var(--blue-700)",
          bg: "var(--blue-100)",
        };
      case "partly":
      case "pending":
      case "kyc pending":
        return {
          color: "var(--orange-700)",
          bg: "var(--orange-100)",
        };
      case "kyc requested":
      case "bank":
        return {
          color: "var(--neutral-500)",
          bg: "var(--neutral-100)",
        };
      default:
        return {
          color: "var(--neutral-500)",
          bg: "var(--neutral-100)",
        };
    }
  };

  return (
    <div
      style={{
        ...styles,
        display: styles?.display || "flex",
        alignItems: styles?.alignItems || "center",
        justifyContent: styles?.justifyContent || "center",
        borderRadius: styles?.borderRadius || 4,
        padding: styles?.padding || "2px 6px",
        fontWeight: styles?.fontWeight || 600,
        fontSize: styles?.fontSize || 12,
        background:
          styles?.background || `${returnStatusColor(statusString).bg}`,
        color: styles?.color || returnStatusColor(statusString).color,
        textTransform: styles?.textTransform || "capitalize",
        width: "max-content",
      }}
    >
      {handleRemoveUnderscore(statusString?.toLowerCase())}
    </div>
  );
};

export default StatusField;
